import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/presupuestos-de-ingresos/';

/**
 * GET Presupuestos de Ingresos
 * @returns {Promise<Array<object>>}
 */
export const getPresupuestosDeIngresos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Presuppuesto de Ingresos
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPresupuestoDeIngresos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Presuppuesto de Ingresos
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPresupuestoDeIngresos = async (_values) => {
  try {
    const values = { ..._values };
    values.anio_fiscal = parseInt(_values.anio_fiscal?.format('YYYY'), 10);
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Presuppuesto de Ingresos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPresupuestoDeIngresos = async (id, _values) => {
  try {
    const values = { ..._values };
    values.anio_fiscal = parseInt(_values.anio_fiscal?.format('YYYY'), 10);
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Presuppuesto de Ingresos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePresupuestoDeIngresos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
